module.exports = __webpack_public_path__ + "static/20-3587a3ff9762be9436121c619d8c5e45.jpg";